import { Link } from 'react-router-dom'
import { useBreadcrumbStore } from '@/store/ui'
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbSeparator } from "@/components/ui/breadcrumb"

const BreadCrumb = () => {
    const { breadcrumbItems, customBreadcrumbItems, isCustomOverride } = useBreadcrumbStore()
    
    // Use custom breadcrumbs if override is active, otherwise use default breadcrumbs
    const displayItems = isCustomOverride && customBreadcrumbItems ? customBreadcrumbItems : breadcrumbItems;
    
    return (
        <Breadcrumb>
            <BreadcrumbList className="flex items-center space-x-1 overflow-hidden">
                {displayItems.map((breadcrumbItem, index) => {
                    const isLastItem = index === displayItems.length - 1;   
                    const isCurrentPage = !breadcrumbItem.href || breadcrumbItem.href === '';
                    
                    return (
                        <div key={index} className='flex items-center gap-1.5 sm:gap-2.5 text-sm text-slate-500 dark:text-slate-400 min-w-0 flex-shrink'>
                            <BreadcrumbItem className="min-w-0 flex-shrink">
                                {isCurrentPage || isLastItem ? (
                                    <span className='text-sm text-[#070B14] truncate max-w-[200px] sm:max-w-[300px]' title={breadcrumbItem.name}>
                                        {breadcrumbItem.name}
                                    </span>
                                ) : (
                                    <Link 
                                        className='text-sm text-[#070B14] hover:text-blue-600 truncate max-w-[200px] sm:max-w-[300px] block' 
                                        to={breadcrumbItem.href}
                                        title={breadcrumbItem.name}
                                    >
                                        {breadcrumbItem.name}
                                    </Link>
                                )}
                            </BreadcrumbItem>
                            {!isLastItem && <BreadcrumbSeparator className="flex-shrink-0" />}
                        </div>
                    )
                })}
            </BreadcrumbList>
        </Breadcrumb>
    )
}

export default BreadCrumb